import React from 'react'

export function CyberMech({ className = '', pose = 'idle' }) {
  return (
    <svg
      viewBox="0 0 200 300"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="cm-mechMetal" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#475569" />
          <stop offset="50%" stopColor="#1e293b" />
          <stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
        <linearGradient id="cm-mechHighlight" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#94a3b8" />
          <stop offset="100%" stopColor="#334155" />
        </linearGradient>
        <filter id="cm-cyanGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="cm-beamGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="cm-shieldGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <style>
        {`
          @keyframes cm-hover {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
          }
          @keyframes cm-corePulse {
            0%, 100% { transform: scale(1); opacity: 0.8; }
            50% { transform: scale(1.1); opacity: 1; }
          }
          @keyframes cm-recoil {
            0%, 100% { transform: translateX(0); }
            10% { transform: translateX(-15px); }
            50% { transform: translateX(-5px); }
          }
          @keyframes cm-beamPulse {
            0%, 100% { opacity: 0.8; transform: scaleY(0.9); }
            50% { opacity: 1; transform: scaleY(1.1); }
          }
          @keyframes cm-blastOff {
            0%, 100% { transform: translateY(-10px); }
            50% { transform: translateY(-20px); }
          }
          @keyframes cm-glitch {
            0%, 100% { transform: translate(0, 0); }
            20% { transform: translate(-2px, 2px); }
            40% { transform: translate(2px, -2px); }
            60% { transform: translate(-2px, -2px); }
            80% { transform: translate(2px, 2px); }
          }
          @keyframes cm-shieldPulse {
            0%, 100% { opacity: 0.7; }
            50% { opacity: 0.9; }
          }
          
          .cm-idle-anim { animation: cm-hover 4s ease-in-out infinite; }
          .cm-core-anim { animation: cm-corePulse 2s ease-in-out infinite; transform-origin: center; }
          .cm-attack-anim { animation: cm-recoil 0.5s ease-out infinite; }
          .cm-beam-anim { animation: cm-beamPulse 0.1s infinite; transform-origin: left center; }
          .cm-jump-anim { animation: cm-blastOff 2s ease-in-out infinite; }
          .cm-hurt-anim { animation: cm-glitch 0.2s infinite; }
          .cm-shield-anim { animation: cm-shieldPulse 1.5s infinite; }
        `}
      </style>

      {pose === 'idle' && (
        <g className="cm-idle-anim">
          <g fill="#06b6d4" filter="url(#cm-cyanGlow)" opacity="0.8">
            <path d="M60 250 L75 290 L90 250 Z" className="cm-core-anim" />
            <path
              d="M110 250 L125 290 L140 250 Z"
              className="cm-core-anim"
              style={{ animationDelay: '0.2s' }}
            />
          </g>
          <g transform="translate(140, 100)">
            <rect
              x="0"
              y="0"
              width="30"
              height="80"
              rx="5"
              fill="url(#cm-mechMetal)"
            />
            <rect
              x="-5"
              y="70"
              width="40"
              height="30"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
            <circle
              cx="15"
              cy="85"
              r="5"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
            />
          </g>
          <g transform="translate(50, 180)">
            <path d="M10 0 L40 0 L45 70 L5 70 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="0"
              y="60"
              width="50"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>
          <g transform="translate(100, 180)">
            <path d="M10 0 L40 0 L45 70 L5 70 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="0"
              y="60"
              width="50"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>
          <g transform="translate(100, 130)">
            <path
              d="M-60 -60 L60 -60 L50 60 L-50 60 Z"
              fill="url(#cm-mechMetal)"
            />
            <path
              d="M-40 -40 L40 -40 L30 40 L-30 40 Z"
              fill="url(#cm-mechHighlight)"
            />
            <circle cx="0" cy="0" r="25" fill="#0f172a" />
            <circle
              cx="0"
              cy="0"
              r="18"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
              className="cm-core-anim"
            />
            <circle cx="0" cy="0" r="10" fill="#ffffff" />
            <rect x="-35" y="-30" width="15" height="4" fill="#020617" />
            <rect x="-35" y="-20" width="15" height="4" fill="#020617" />
            <rect x="20" y="-30" width="15" height="4" fill="#020617" />
            <rect x="20" y="-20" width="15" height="4" fill="#020617" />
          </g>
          <g transform="translate(100, 50)">
            <rect
              x="-20"
              y="-20"
              width="40"
              height="40"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
            <path
              d="M-25 0 L-20 -10 L20 -10 L25 0 Z"
              fill="url(#cm-mechMetal)"
            />
            <rect x="-15" y="-5" width="30" height="10" rx="2" fill="#020617" />
            <rect
              x="-10"
              y="-3"
              width="20"
              height="6"
              rx="1"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
              className="cm-core-anim"
            />
            <rect
              x="15"
              y="-35"
              width="4"
              height="20"
              fill="url(#cm-mechMetal)"
            />
            <circle
              cx="17"
              cy="-35"
              r="3"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
            />
          </g>
          <g transform="translate(30, 90)">
            <circle cx="20" cy="20" r="25" fill="url(#cm-mechHighlight)" />
            <path
              d="M5 30 L35 30 L45 110 L-5 110 Z"
              fill="url(#cm-mechMetal)"
            />
            <rect
              x="-10"
              y="110"
              width="60"
              height="30"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
            <rect x="0" y="140" width="40" height="20" fill="#0f172a" />
            <ellipse
              cx="20"
              cy="160"
              rx="15"
              ry="5"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
              className="cm-core-anim"
            />
          </g>
        </g>
      )}

      {pose === 'attack' && (
        <g className="cm-attack-anim">
          {/* Braced Legs */}
          <g transform="translate(30, 180) rotate(-10)">
            <path d="M10 0 L40 0 L45 70 L5 70 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="0"
              y="60"
              width="50"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>
          <g transform="translate(110, 180) rotate(10)">
            <path d="M10 0 L40 0 L45 70 L5 70 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="0"
              y="60"
              width="50"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>

          {/* Torso leaning back */}
          <g transform="translate(90, 130) rotate(-15)">
            <path
              d="M-60 -60 L60 -60 L50 60 L-50 60 Z"
              fill="url(#cm-mechMetal)"
            />
            <path
              d="M-40 -40 L40 -40 L30 40 L-30 40 Z"
              fill="url(#cm-mechHighlight)"
            />
            <circle cx="0" cy="0" r="25" fill="#0f172a" />
            <circle
              cx="0"
              cy="0"
              r="18"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
            />
            <circle cx="0" cy="0" r="10" fill="#ffffff" />

            {/* Energy lines to cannon */}
            <path
              d="M0 0 L80 -20"
              stroke="#06b6d4"
              strokeWidth="4"
              filter="url(#cm-cyanGlow)"
            />
          </g>

          {/* Head forward */}
          <g transform="translate(110, 50)">
            <rect
              x="-20"
              y="-20"
              width="40"
              height="40"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
            <path
              d="M-25 0 L-20 -10 L20 -10 L25 0 Z"
              fill="url(#cm-mechMetal)"
            />
            <rect x="-15" y="-5" width="30" height="10" rx="2" fill="#020617" />
            <rect
              x="-10"
              y="-3"
              width="20"
              height="6"
              rx="1"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
            />
          </g>

          {/* Cannon Arm extended horizontally */}
          <g transform="translate(120, 100) rotate(-90)">
            <circle cx="20" cy="20" r="25" fill="url(#cm-mechHighlight)" />
            <path
              d="M5 30 L35 30 L45 110 L-5 110 Z"
              fill="url(#cm-mechMetal)"
            />
            <rect
              x="-10"
              y="110"
              width="60"
              height="30"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
            <rect x="0" y="140" width="40" height="20" fill="#0f172a" />

            {/* Massive Energy Beam */}
            <g transform="translate(20, 160)" className="cm-beam-anim">
              <path
                d="M-20 0 L20 0 L10 150 L-10 150 Z"
                fill="#ffffff"
                filter="url(#cm-beamGlow)"
              />
              <path
                d="M-30 0 L30 0 L15 150 L-15 150 Z"
                fill="#06b6d4"
                filter="url(#cm-beamGlow)"
                opacity="0.6"
              />
              <circle
                cx="0"
                cy="0"
                r="30"
                fill="#ffffff"
                filter="url(#cm-beamGlow)"
              />
            </g>
          </g>
        </g>
      )}

      {pose === 'jump' && (
        <g className="cm-jump-anim">
          {/* Massive Thruster Flames */}
          <g fill="#06b6d4" filter="url(#cm-cyanGlow)">
            <path d="M50 250 L75 350 L100 250 Z" className="cm-core-anim" />
            <path
              d="M100 250 L125 350 L150 250 Z"
              className="cm-core-anim"
              style={{ animationDelay: '0.1s' }}
            />
            <path
              d="M40 250 L75 320 L110 250 Z"
              fill="#ffffff"
              className="cm-core-anim"
            />
            <path
              d="M90 250 L125 320 L160 250 Z"
              fill="#ffffff"
              className="cm-core-anim"
              style={{ animationDelay: '0.1s' }}
            />
          </g>

          {/* Straight Legs */}
          <g transform="translate(50, 180)">
            <path d="M10 0 L40 0 L40 70 L10 70 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="5"
              y="60"
              width="40"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>
          <g transform="translate(100, 180)">
            <path d="M10 0 L40 0 L40 70 L10 70 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="5"
              y="60"
              width="40"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>

          {/* Torso straight */}
          <g transform="translate(100, 130)">
            <path
              d="M-50 -60 L50 -60 L45 60 L-45 60 Z"
              fill="url(#cm-mechMetal)"
            />
            <path
              d="M-30 -40 L30 -40 L25 40 L-25 40 Z"
              fill="url(#cm-mechHighlight)"
            />
            <circle cx="0" cy="0" r="25" fill="#0f172a" />
            <circle
              cx="0"
              cy="0"
              r="18"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
            />
            <circle cx="0" cy="0" r="10" fill="#ffffff" />
          </g>

          {/* Head looking up */}
          <g transform="translate(100, 45) rotate(-10)">
            <rect
              x="-20"
              y="-20"
              width="40"
              height="40"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
            <path
              d="M-25 0 L-20 -10 L20 -10 L25 0 Z"
              fill="url(#cm-mechMetal)"
            />
            <rect
              x="-15"
              y="-10"
              width="30"
              height="10"
              rx="2"
              fill="#020617"
            />
            <rect
              x="-10"
              y="-8"
              width="20"
              height="6"
              rx="1"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
            />
          </g>

          {/* Arms straight down */}
          <g transform="translate(30, 100)">
            <rect
              x="0"
              y="0"
              width="30"
              height="80"
              rx="5"
              fill="url(#cm-mechMetal)"
            />
            <rect
              x="-5"
              y="70"
              width="40"
              height="30"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
          </g>
          <g transform="translate(140, 100)">
            <rect
              x="0"
              y="0"
              width="30"
              height="80"
              rx="5"
              fill="url(#cm-mechMetal)"
            />
            <rect
              x="-5"
              y="70"
              width="40"
              height="30"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
          </g>
        </g>
      )}

      {pose === 'hurt' && (
        <g className="cm-hurt-anim">
          {/* Sparks */}
          <g fill="#fef08a" filter="url(#cm-cyanGlow)">
            <circle cx="60" cy="120" r="3" />
            <circle cx="140" cy="160" r="4" />
            <circle cx="80" cy="200" r="2" />
            <path
              d="M90 130 L110 150 M100 120 L120 140"
              stroke="#fef08a"
              strokeWidth="2"
            />
          </g>

          {/* Displaced Legs */}
          <g transform="translate(40, 180) rotate(15)">
            <path d="M10 0 L40 0 L45 70 L5 70 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="0"
              y="60"
              width="50"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>
          <g transform="translate(110, 190) rotate(-5)">
            <path d="M10 0 L40 0 L45 70 L5 70 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="0"
              y="60"
              width="50"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>

          {/* Torso tilted */}
          <g transform="translate(100, 140) rotate(20)">
            <path
              d="M-60 -60 L60 -60 L50 60 L-50 60 Z"
              fill="url(#cm-mechMetal)"
            />
            {/* Broken chest plate */}
            <path
              d="M-40 -40 L40 -40 L30 40 L-10 20 L-20 40 Z"
              fill="url(#cm-mechHighlight)"
            />
            <circle cx="0" cy="0" r="25" fill="#0f172a" />
            {/* Flickering red core */}
            <circle
              cx="0"
              cy="0"
              r="18"
              fill="#ef4444"
              filter="url(#cm-cyanGlow)"
              className="cm-core-anim"
            />
          </g>

          {/* Head tilted */}
          <g transform="translate(130, 70) rotate(35)">
            <rect
              x="-20"
              y="-20"
              width="40"
              height="40"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
            <path
              d="M-25 0 L-20 -10 L20 -10 L25 0 Z"
              fill="url(#cm-mechMetal)"
            />
            <rect x="-15" y="-5" width="30" height="10" rx="2" fill="#020617" />
            {/* Dead visor */}
            <rect x="-10" y="-3" width="20" height="6" rx="1" fill="#1e293b" />
          </g>

          {/* Arms flailing */}
          <g transform="translate(140, 120) rotate(45)">
            <rect
              x="0"
              y="0"
              width="30"
              height="80"
              rx="5"
              fill="url(#cm-mechMetal)"
            />
          </g>
          <g transform="translate(20, 110) rotate(-30)">
            <path
              d="M5 30 L35 30 L45 110 L-5 110 Z"
              fill="url(#cm-mechMetal)"
            />
            <rect
              x="-10"
              y="110"
              width="60"
              height="30"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
          </g>
        </g>
      )}

      {pose === 'block' && (
        <g>
          {/* Crouched Legs */}
          <g transform="translate(40, 200)">
            <path d="M10 0 L40 0 L50 50 L0 50 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="-5"
              y="40"
              width="60"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>
          <g transform="translate(100, 200)">
            <path d="M10 0 L40 0 L50 50 L0 50 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="-5"
              y="40"
              width="60"
              height="20"
              rx="3"
              fill="url(#cm-mechHighlight)"
            />
          </g>

          {/* Torso crouched */}
          <g transform="translate(100, 150)">
            <path
              d="M-60 -50 L60 -50 L50 50 L-50 50 Z"
              fill="url(#cm-mechMetal)"
            />
            <path
              d="M-40 -30 L40 -30 L30 30 L-30 30 Z"
              fill="url(#cm-mechHighlight)"
            />
            <circle cx="0" cy="0" r="25" fill="#0f172a" />
            <circle
              cx="0"
              cy="0"
              r="18"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
            />
          </g>

          {/* Head tucked */}
          <g transform="translate(100, 80)">
            <rect
              x="-20"
              y="-20"
              width="40"
              height="40"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
            <rect x="-15" y="-5" width="30" height="10" rx="2" fill="#020617" />
            <rect
              x="-10"
              y="-3"
              width="20"
              height="6"
              rx="1"
              fill="#06b6d4"
              filter="url(#cm-cyanGlow)"
            />
          </g>

          {/* Cannon Arm projecting shield */}
          <g transform="translate(100, 150) rotate(90)">
            <path d="M5 30 L35 30 L45 80 L-5 80 Z" fill="url(#cm-mechMetal)" />
            <rect
              x="-10"
              y="80"
              width="60"
              height="20"
              rx="5"
              fill="url(#cm-mechHighlight)"
            />
          </g>

          {/* Massive Energy Shield */}
          <g transform="translate(100, 150)" className="cm-shield-anim">
            <path
              d="M-80 -100 L80 -100 L120 0 L80 100 L-80 100 L-120 0 Z"
              fill="#06b6d4"
              fillOpacity="0.2"
              stroke="#06b6d4"
              strokeWidth="4"
              filter="url(#cm-shieldGlow)"
            />
            {/* Hexagon pattern */}
            <path
              d="M-40 -50 L40 -50 L60 0 L40 50 L-40 50 L-60 0 Z"
              stroke="#ffffff"
              strokeWidth="2"
              fill="none"
              opacity="0.5"
            />
            <path
              d="M0 -100 L0 100 M-80 -50 L80 50 M-80 50 L80 -50"
              stroke="#06b6d4"
              strokeWidth="2"
              opacity="0.3"
            />
          </g>
        </g>
      )}
    </svg>
  )
}
